const FORM_MODEL_PREFIX = /^(?:object_localization|platform_object)\./
const GENERIC_ASSOCIATION_FIELDS = new Set(['object_localization', 'platform_object'])
const GENERIC_INVALID_MESSAGE = /^(?:ist nicht gültig|is invalid)$/i

function errorMessage(value) {
  if (Array.isArray(value)) {
    return value.map(errorMessage).filter(Boolean).join(', ')
  }

  if (value && typeof value === 'object') {
    return Object.values(value).map(errorMessage).filter(Boolean).join(', ')
  }

  return value == null ? '' : String(value)
}

function formFieldName(field) {
  return String(field)
    .replace(FORM_MODEL_PREFIX, '')
    .replace(/^event_dates\[(\d+)]\./, 'event_dates_attributes[$1].')
    .replace(/^event_dates\.(\d+)\./, 'event_dates_attributes[$1].')
}

export function normalizeApiValidationErrors(payload) {
  const source = payload?.errors ?? payload
  if (!source || typeof source !== 'object' || Array.isArray(source)) {
    const message = errorMessage(source)
    return message ? {base: message} : {}
  }

  const entries = Object.entries(source)
    .map(([field, value]) => ({
      originalField: field,
      field: formFieldName(field),
      message: errorMessage(value),
    }))
    .filter(({message}) => Boolean(message))

  const hasSpecificError = entries.some(({originalField}) => !GENERIC_ASSOCIATION_FIELDS.has(originalField))
  const actionableEntries = hasSpecificError
    ? entries.filter(({originalField, message}) => (
      !GENERIC_ASSOCIATION_FIELDS.has(originalField) || !GENERIC_INVALID_MESSAGE.test(message)
    ))
    : entries

  return actionableEntries.reduce((errors, {field, message}) => {
    const targetField = field || 'base'
    errors[targetField] = errors[targetField]
      ? `${errors[targetField]}, ${message}`
      : message
    return errors
  }, {})
}
